import { RandomHexFactory } from './random-hex-factory.model';
import { createSpanContext } from './create-span-context.function';
import { serializeSpanContext } from './serialize-span-context.function';

export function createTraceparent(randomHex: RandomHexFactory): string {
  return serializeSpanContext(createSpanContext(randomHex));
}
